import { render, staticRenderFns } from "./TasksGrid.vue?vue&type=template&id=2fb28fad&scoped=true&"
import script from "./TasksGrid.vue?vue&type=script&setup=true&lang=js&"
export * from "./TasksGrid.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb28fad",
  null
  
)

export default component.exports